import { H2, P, theme } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import data from './data';
import DestinationTile, { DestinationProps } from './components/destination-tile';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';
import WrappedSection from '../../../../components/sections/wrapped-section';

const { media } = theme;

const Subtitle = styled(P)`
  margin: 0 auto;
  max-width: 600px;
`;

const TileWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 2rem;
  flex-direction: column;

  @media (min-width: ${media.md}) {
    align-items: normal;
    flex-direction: row;
    justify-content: center;
  }
`;

const PopularDestinationsSection = () => (
  <WrappedSection withBorder withWide>
    <H2 variant="center">Popular destinations</H2>
    <Subtitle variant={['center', 'marginBottomSpacer8']}>
      We know how much Aussies love flocking overseas, so we’ve simplified your travel insurance search with some of ahm
      customers’ favourite destinations.
    </Subtitle>

    <TileWrapper>
      {uncapFpIterator(map)(
        (destination: DestinationProps, index: number) => (
          <DestinationTile key={index} {...destination} />
        ),
        data,
      )}
    </TileWrapper>
  </WrappedSection>
);

export default PopularDestinationsSection;
